/**
 * Goods Receipting “Placed” column: person first, channel last.
 *
 * Preference: placedByDisplay (resolved name) → placedBy (often email) →
 * placedVia (dashboard / mobile / manual) → venue-code fallback.
 * Tooltip keeps the channel when we show a person.
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

function normalise(value) {
  return String(value || '').trim()
}

/**
 * Chef-facing channel label for tooltips.
 * @param {string} placedVia
 */
export function formatGoodsReceiptingPlacedChannel(placedVia = '') {
  const via = normalise(placedVia)
  if (!via) return ''

  const lower = via.toLowerCase()
  if (lower === 'dashboard') return 'dashboard'
  if (lower === 'mobile') return 'mobile app'
  if (lower.includes('manually') || lower.includes('manual')) {
    return 'manual order'
  }
  if (lower.includes('venue code')) return 'venue code'
  return via
}

/**
 * @param {{
 *   placedBy?: string|null,
 *   placedByDisplay?: string|null,
 *   placedVia?: string|null,
 * }} [order]
 * @returns {{
 *   label: string,
 *   tooltip: string,
 *   channel: string,
 *   placedBy: string,
 *   isPerson: boolean,
 * }}
 */
export function getGoodsReceiptingPlacedDisplay(order = {}) {
  const placedByDisplay = normalise(order.placedByDisplay)
  const placedBy = normalise(order.placedBy)
  const placedVia = normalise(order.placedVia)
  const channel = formatGoodsReceiptingPlacedChannel(placedVia)

  // Name (resolved) → raw placedBy (name or email) → channel string.
  const person = placedByDisplay || placedBy
  const isPerson = Boolean(person)
  const label = person || placedVia || 'Placed using venue code'

  let tooltip = label
  if (isPerson && channel) {
    tooltip = `${person} · via ${channel}`
  } else if (!isPerson && placedVia) {
    tooltip = placedVia
  }

  return {
    label,
    tooltip,
    channel: placedVia,
    placedBy: person,
    isPerson,
    isEmail: Boolean(person && EMAIL_RE.test(person)),
  }
}
